import { City } from "../interfaces/city";

export function removeIndustrialCity(cityName: string, language: string = "en") {
  if (language === "ar") {
    const match = cityName.match(/^(مدينة) (.+) (الصناعية)$/);
    if (match) {
      return { cleanedName: match[2], wasRemoved: true, prefix: `${match[1]} `, suffix: ` ${match[3]}` };
    }
  } else {
    const match = cityName.match(/^(.+) (Industrial City)$/i);
    if (match) {
      return { cleanedName: match[1], wasRemoved: true, prefix: "", suffix: ` ${match[2]}` };
    }
  }
  return { cleanedName: cityName, wasRemoved: false, prefix: "", suffix: "" };
}

export function getCityName(
  city: City,
  language: string,
  fallback: string,
): string {
  if (language === "ar" && city.nameAr) {
    return city.nameAr;
  }
  if (language === "en" && city.nameEn) {
    return city.nameEn;
  }
  return fallback;
}
